import classnames from 'classnames';
import React from 'react';

const CSS = require('./AspectRatio.module.scss');

interface AspectRatioProps {
  className?: string;
  children: (className: string) => any;
  aspectRatio:
    | '1:1'
    | '16:9'
    | '9:16'
    | '4:3'
    | '3:4'
    | '2:3'
    | '3:2'
    | '2:1'
    | '4:1'
    | '5:1'
    | '5:2'
    | '21:9';
}

function AspectRatio({ className, children, aspectRatio }: AspectRatioProps) {
  const classes = classnames(CSS.Container, {
    [CSS.TwentyOneNine]: aspectRatio === '21:9',
    [CSS.SixteenNine]: aspectRatio === '16:9',
    [CSS.NineSixteen]: aspectRatio === '9:16',
    [CSS.ThreeFour]: aspectRatio === '3:4',
    [CSS.FourThree]: aspectRatio === '4:3',
    [CSS.ThreeTwo]: aspectRatio === '3:2',
    [CSS.TwoOne]: aspectRatio === '2:1',
    [CSS.FourOne]: aspectRatio === '4:1',
    [CSS.FiveOne]: aspectRatio === '5:1',
    [CSS.FiveTwo]: aspectRatio === '5:2',
    [CSS.TwoThree]: aspectRatio === '2:3',
    [className]: className,
  });

  return <div className={classes}>{children(CSS.Child)}</div>;
}

export default AspectRatio;
